function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}


const Grid = {
    _gridElem: '',
    _gridElemTable: '',
    _data: {},
    _donations: {},
    _warningAudio: new Audio("/assets/mp3/vibration.mp3"),
    _boxSize: 10,
    _pixelSize: 10,
    _pixelPositions: [],
    _price: 0,
    _selected: [],
    _info_card: $('.info-card'),

    init: function (elem) {
        $('.pixel-selector').css('visibility', 'hidden');

        this._price = $('.selectBox.selected').data('price');

        this._gridElem = elem;
        this._gridElemTable = `${elem} .grid-table`;
        this._data = $(elem).data('grid');
        this._donations = $(elem).data('donations');
        this._pixelSize = this._data.pixel_size;
        this._boxSize = this._pixelSize;

        this._createGrid();
        this._listenOnScroll();
        this._setPixelPositions();
        this._start();
        this._listenOnClick();
        this._listenSelectBoxOnClick();
        this._listenBookedPixels();
    },

    _setPixelPositions: function () {
        const that = this;
        that._pixelPositions = [];
        $('.pixel').each(function (i, el) {
            let obj = {
                ...$(el).offset(),
                'id': $(el).attr('id'),
                ...$(el).data()
            }

            that._pixelPositions.push(obj);
        });
    },

    getPixelPositions: function () {
        return this._pixelPositions;
    },

    _createGrid: function () {
        const width = this._data.width;
        const height = this._data.height;

        let row = '';
        for (let x = 1; x <= height; x++) {
            row += '<div class="tr">'

            for (let y = 1; y <= width; y++) {

                let pixel = this._data.pixels.find(p => (p.x === x && p.y === y));

                let donation = this._donations.find(donation => (donation.pixel_uuid === pixel.uuid));


                row += `<div class="pixel td  " id='${x}-${y}'
                            data-booked="${pixel.booked}"
                            data-sold="${pixel.sold}"
                            data-x="${pixel.x}"
                            data-y="${pixel.y}"
                            data-uuid="${pixel.uuid}"
                            data-donation='${JSON.stringify(donation)}'
                            data-pixel='${JSON.stringify(pixel)}'
                            >


                            <div class="inner-pixel "></div>
                            </div>`
            }

            row += '</div>';
        }

        $(this._gridElemTable).html(row);
    },

    _start: function () {
        const that = this;

        $(this._gridElem).on('mousemove', function (event) {

            $('.pixel-selector').removeClass('booked');

            let x = event.pageX - that._boxSize;
            let y = event.pageY - that._boxSize;

            let position = that._pixelPositions.find((p) => {

                if (x < p.left && y < p.top) {
                    return true;
                }
            });

            
            $('.pixel-selector').css({'top': position.top, 'left': position.left});
            $('.tooltip-text').css({'top': position.top, 'left': position.left + 30});

            if (position.booked && !position.sold) {
                $('.tooltip-text').show();
            } else {
                $('.tooltip-text').hide();
            }

        });
    },

    _listenOnClick: function () {

        const that = this;
        let showInfo = false;

        $(this._gridElem).on('click', function () {
            that._info_card.fadeOut();
            const pixelSelectorTd = $('.pixel-selector .table .td');
            $('.pixel').removeClass('checked');
            $('.select-pixel-btn').show();
            $('.buy-pixel-btn').hide();
            $('.buy-pixel-btn').find('#pixel-price').html(0);

            that._selected = [];

            pixelSelectorTd.each(function (i, el) {
                let item = $(el).offset();

                let findPixel = that._pixelPositions.find((p) => {
                    if (p.top === item.top && p.left === item.left) {

                        if (p.sold) {

                            showInfo = true;

                            $('.info-card').hide();
                            that._showInfo(p.uuid);

                            return false;

                        }

                        if (p.booked) {
                            $('.pixel-selector').addClass('booked');
                            that._warningAudio.play();

                            return false;

                        }

                        $('#' + p.id).addClass('checked');

                        return true;
                    }
                });

                if (findPixel) {
                    that._selected.push(findPixel);
                } else {
                    return false;
                }

            });

            if (pixelSelectorTd.length === that._selected.length && parseInt(that._price) > 0) {
                $('.select-pixel-btn').hide();
                $('.buy-pixel-btn').show();
                $('.buy-pixel-btn').find('#pixel-price').html(that._price);
            } else {
                $('.pixel').removeClass('checked');
                that._selected = [];

                if (!showInfo) {
                    if ($('.selectbox-buttons-container').find('.selected').length === 0) {

                        $('.selectbox-buttons-container').addClass('animated-bounce');
                        setTimeout(function () {

                            $('.selectbox-buttons-container').removeClass('animated-bounce');
                            showInfo = false;

                        }, 500);
                    }


                }

            }

            showInfo = false;


        });
    },

    _listenSelectBoxOnClick: function () {
        const that = this;
        $('.selectBox').click(function () {
            $('.selectBox').removeClass('selected');
            $(this).addClass('selected');


            let size = $(this).data('size');
            let price = $(this).data('price');

            that._boxSize = size;
            that._price = price;

            $('.pixel-selector').css('visibility', 'initial');

            $('.select-pixel-btn').show();
            $('.buy-pixel-btn').hide();

            $('.select-pixel-btn').html(`<span class="icon-arrow-up"></span> Sahə seç (${that._price} AZN)`);

            $('.pixel-selector').css({'width': size, 'height': size});

            let table = '<div class="table">';

            for (let x = 0; x < (size / that._pixelSize); x++) {
                table += '<div class="tr">'

                for (let y = 0; y < (size / that._pixelSize); y++) {
                    table += '<div class="td"></div>'
                }

                table += '</div>'
            }

            table += '</div>'

            $('.pixel-selector').html(table);
        });
    },

    _listenOnScroll: function () {
        const that = this;

        $(document).on('scroll', function () {
            $('.pixel').removeClass('checked');
            that._setPixelPositions();
        });

        $(this._gridElem).on('scroll', function () {
            $('.pixel').removeClass('checked');
            that._setPixelPositions();
        });

        window.visualViewport.addEventListener("resize", function (event) {
            $('.pixel').removeClass('checked');
            that._setPixelPositions();
        });

    },

    _buyPixel: function (e) {

        $(e).attr('disabled', 'disabled');
        let that = this;

        grecaptcha.ready(function() {
            grecaptcha.execute($('#recaptcha').val(), {action: 'submit'}).then(function(token) {

                $.ajax({
                    url: '/buy-pixel/first-step',
                    method: 'POST',
                    dataType: 'JSON',
                    data: {
                        price: that._price,
                        pixels: that._selected,
                        recaptcha: token
                    },
                    success: function (data) {

                        const transaction_id = data.transaction_id;

                        setCookie('transaction_id', transaction_id, 1);

                        window.location.assign(`/buy-pixel?transaction_id=${transaction_id}`);


                        console.log(data);
                    },
                    error: function (res) {
                        ajaxSetup.error(res);
                        $(e).removeAttr('disabled');
                    }
                });

            });
        });



    },

    _listenBookedPixels: function () {
        const that = this;

        function bookedPixels() {
            $.ajax({
                url: '/booked-pixels',
                dataType: 'JSON',
                success: function (res) {
                    for (let i = 0; i < res.pixels.length; i++) {

                        let el = $(`.pixel[data-uuid="${res.pixels[i].uuid}"]`);
                        el.attr('data-booked', res.pixels[i].booked);
                        el.attr('data-sold', res.pixels[i].sold);

                        let pixel = that._pixelPositions.find(p => p.uuid === res.pixels[i].uuid);
                        pixel.booked = res.pixels[i].booked;
                        pixel.sold = res.pixels[i].sold;

                    }
                }
            });
        }

        bookedPixels();

        setInterval(function () {
            bookedPixels();
        }, 3000);

    },

    _showInfo(uuid) {
        const that = this;
        let donation = $(`.pixel[data-uuid="${uuid}"]`).data('donation');

        let link = donation.link;

        if(link == null || link == "null"){
            link = "https://turan100k.az";
        }

        if(donation.message == null || donation.message == "null"){
            donation.message = "";
        }


        /*if (link && link.length > 0) {

            link = donation.link.replace('https://', '');
            link = donation.link.replace('http://', '');
            link = donation.link.replace('www.', '');
        }

        link = 'https://' + link;*/

        let w = 0;
        let h = 0;

        if(parseInt(donation.photo_width) == parseInt(donation.photo_height)){
            w = 300;
            h = 300;
        }else{
            w = parseInt(donation.photo_width) * 100;
            h = parseInt(donation.photo_height) * 100;
        }


        let pixel_size = parseInt(donation.photo_width) * parseInt(donation.photo_height);
        that._info_card.find('.photo .image').html(`<a href="${link}" target="_blank"><img src="/resizer.php?src=https://${window.location.hostname}/storage/${donation.pixel_photo}&w=${w}&h=${h}&zc=1&q=80" alt="photo" class="img-fluid w-100"/></a>`);
        that._info_card.find('.pixel-info').html(`<img src="/assets/img/9px-black.svg" alt="pixel" width="24"/> <span>${pixel_size} piksel</span>`);
        that._info_card.find('.link').attr('href', link);


        that._info_card.find('.name').html(`<a href="https://${window.location.hostname}/storage/${donation.pixel_photo}" target="_blank">${donation.name}</a>`);
        that._info_card.find('.message').html(`${donation.message}`);

        setTimeout(function () {
            that._info_card.fadeIn();
        }, 200);

    }

}
window.grid = Grid;

const cookieTransactionId = getCookie('transaction_id');

if (cookieTransactionId) {
    $.ajax({
        type: 'POST',
        url: '/buy-pixel/second-step',
        data: {
            transaction_id: cookieTransactionId,
            submit: false,
        },
        success: function (res) {
            eraseCookie('transaction_id');
        },
        error: function (res) {
            eraseCookie('transaction_id');
        }
    })
}

$(document).ready(function () {

    if (window.location.hash === '#list-of-buyers') {
        $('.show-buyers-btn').click();
    }

    const __ball_loading = $('.ball-loading');

    __ball_loading.show();

    const grid_id = $('.grid-table-wrapper').data('grid-id');

    let percentage = 0;
    $.ajax({
        /*xhr: function () {
            /!*let httpReq = new XMLHttpRequest();//monitor an upload's progress. //amount of progress
            httpReq.addEventListener("progress", function (ele) {

                //if (ele.lengthComputable) {//property is a boolean flag indicating if the resource concerned by the ProgressEvent has a length that can be calculated.
                    percentage = ((ele.loaded / ele.total) * 100);
                    $("#progress-bar").css("width", percentage + "%");
                    $("#progress-bar").html(Math.round(percentage) + "%");

                    console.log(percentage);
                //}
            });
            return httpReq;*!/
        },*/
        url: `/storage/grids/grid_${grid_id}.json?v=` + (new Date().getTime()),
        dataType: 'JSON',
        success: function (resGrid) {

            $('.grid-table-wrapper').data('grid', resGrid.data.grid);

            $.ajax({
                xhr: function () {
                    let httpReq = new XMLHttpRequest();//monitor an upload's progress. //amount of progress
                    httpReq.addEventListener("progress", function (ele) {

                         /*$('body').append("<input value='"+ele.loaded+"'>");
                         $('body').append("<input value='"+ele.total+"'>");*/

                        let total = ele.total;
                        //if(ele.total == 0){
                            let pixelCount = $('.pixel-count').text();
                            pixelCount = 7140 - parseInt(pixelCount);
                            total = pixelCount * 678.53;

                            console.log(total);

                        //}

                        //if (ele.lengthComputable) {//property is a boolean flag indicating if the resource concerned by the ProgressEvent has a length that can be calculated.
                            percentage = ((ele.loaded / total) * 100);

                            if(percentage > 100){
                                percentage = 99;
                            }


                            $("#progress-bar").css("width", percentage + "%");
                            $("#progress-bar").html(Math.round(percentage) + "%");

                            console.log(percentage);
                        //}
                    });
                    return httpReq;
                },
                url: `/storage/grids/donations.json?v=` + (new Date().getTime()),
                dataType: 'JSON',

                beforeSend: function () {

                },
                success: function (res) {

                    $('.grid-table-wrapper').data('donations', res.data.donations);

                    let copyDonations = [...res.data.donations];
                    let donationsGroup = [...new Map(copyDonations.map(item =>
                        [item['donation_id'], item])).values()];

                    donationsGroup.forEach(donation => {
                        let temp = `<li class="list-group-item p-1 mb-2 "
                                        data-uuid="${donation.pixel_uuid}"
                                    >
                                        <div class="list-card" onclick="
                                            $('.info-card').hide();
                                            window.grid._showInfo('${donation.pixel_uuid}');
                                            $(this).closest('.list-of-buyers-container').removeClass('fadeInRight');
                                            $(this).closest('.list-of-buyers-container').addClass('hideInRight');
                                            ">
                                            <div class="d-flex">
                                                <div class="px-2">
                                                    <img src="/storage/${donation.pixel_photo.replace('.png', '-thumb.png')}" class="img-fluid lazy list-card-image">
                                                </div>
                                                <div class="">
                                                    <h3 class="title">${donation.name}</h3>
                                                    <p class="text m-0">${donation.link ?? ""}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </li>`;

                        $('.donation-list').append(temp);


                    });


                    setTimeout(function (){
                        __ball_loading.hide();
                        window.grid.init('.grid-table-wrapper');
                    },1000);


                }
            });
        }
    });

    /*$("#progress-bar").css("width", "10%");
    $("#progress-bar").html("10%");*/

    /*let interval = setInterval(function (){
        if(percentage < 94){
            percentage = percentage + 8
        }

        console.log(percentage);

        $("#progress-bar").css("width", percentage + "%");
        $("#progress-bar").html(Math.round(percentage) + "%");

        if(percentage > 94){
            clearInterval(interval);
        }
    },100);*/


    $(window).scroll(() => {
        const footerToTop = $('footer').position().top;
        const scrollTop = $(document).scrollTop() + $(window).height();
        const difference = scrollTop - footerToTop + 30;
        const bottomValue = scrollTop > footerToTop ? difference : 0;
        $('.selectbox-buttons-container').css('bottom', bottomValue);
    });

});
